import { Modal, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import * as S from './style';

function TotalEstimatedSpendModal({
  featureType = 'recognition',
  isModalOpen,
  onModalOpen,
  isCCPayment
}) {
  const { t } = useTranslation();

  const i18nKey = featureType === 'recognition' ? 'pricingListData' : 'pricingListAutomationData';
  const pricingListData = t(i18nKey, { returnObjects: true, isCCPayment });

  const conditions = {
    isCCPayment: isCCPayment
  };

  return (
    <Modal
      size="sm"
      title={t('howOurPriceWork')}
      isOpen={isModalOpen}
      onRequestClose={onModalOpen}
      primaryButtonProps={{
        onClick: () => onModalOpen(false),
        children: t('okay')
      }}
    >
      <S.PricingList>
        {pricingListData?.map(pricing => {
          const answersWithConditions = pricing?.answers?.[!!conditions?.[pricing?.condition]];
          const answers =
            pricing.condition && !!answersWithConditions?.length
              ? answersWithConditions
              : pricing.answers;

          return (
            <S.Pricing key={pricing.title}>
              <Typography variant="body1Bold">
                <Trans i18nKey={pricing.title} components={{ b: <b /> }} />
              </Typography>

              <S.PricingAnswers>
                {answers?.map(answer => {
                  return (
                    <Typography variant="body2" key={answer}>
                      <Trans i18nKey={answer} components={{ b: <b /> }} />
                    </Typography>
                  );
                })}
              </S.PricingAnswers>
            </S.Pricing>
          );
        })}
      </S.PricingList>
    </Modal>
  );
}

export { TotalEstimatedSpendModal };

TotalEstimatedSpendModal.propTypes = {
  featureType: PropTypes.string,
  isCCPayment: PropTypes.bool,
  isModalOpen: PropTypes.bool.isRequired,
  onModalOpen: PropTypes.func.isRequired
};
